/**
 * Application Entry Point
 * 
 * This file is the main entry point for the React application.
 * It initializes the React root and renders the App component.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// Create React root and render the application
// StrictMode helps identify potential problems in the application
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
